module.exports = __webpack_public_path__ + "img/02_bg.6ddd1f68.png";